import { render, staticRenderFns } from "./ShopVideoOpenTipDialog.vue?vue&type=template&id=7b49aca2&scoped=true"
import script from "./ShopVideoOpenTipDialog.vue?vue&type=script&lang=ts"
export * from "./ShopVideoOpenTipDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShopVideoOpenTipDialog.vue?vue&type=style&index=0&id=7b49aca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b49aca2",
  null
  
)

export default component.exports